var map = {
	"./doc.png": 1610,
	"./drawio.png": 1611,
	"./excel.png": 1612,
	"./exe.png": 1613,
	"./file.png": 1614,
	"./form.png": 1615,
	"./image.png": 1616,
	"./pdf.png": 1617,
	"./powerpoint.png": 1618,
	"./sheet.png": 1619,
	"./slide.png": 1620,
	"./text.png": 1621,
	"./word.png": 1622,
	"./zip.png": 1623
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1609;



//////////////////
// WEBPACK FOOTER
// ./app/assets/file-icons \.png$
// module id = 1609
// module chunks = 0